class SubNavigation {
    available = $state(false);
}


export const subNavigation = new SubNavigation();
